import { Button, InfoBadge, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";
import useTranslation from "../hooks/useTranslation";

export const PaddleBillingPaymentSuccessPage: React.FC = () => {
  const { t, m } = useTranslation();
  const navigation = useNavigation();

  return (
    <InfoPage
      variant="success"
      title={t(m.PaddleBillingPaymentSuccessPage.Title)}
      description={t(m.PaddleBillingPaymentSuccessPage.Description)}
      primaryCTA={
        <Button onClick={() => navigation.goToDownloadPage()}>
          {t(m.PaddleBillingPaymentSuccessPage.DownloadCTA)}
        </Button>
      }
      footer={
        <InfoBadge
          standalone={true}
          description={t(m.PaddleBillingPaymentSuccessPage.AlreadyInstalled)}
          cta={
            <Button
              variant="grayscale"
              onClick={() => navigation.goToShaprApp({ autoOpen: false })}
            >
              {t(m.PaddleBillingPaymentSuccessPage.OpenApp)}
            </Button>
          }
        />
      }
    />
  );
};
